import { HttpClient } from "@angular/common/http";
import { environment as env } from "../../../../../../environments/environment.prod";
import { Injectable } from "@angular/core";
import { AbstractService } from "app/services/abstract.service";
import { Observable } from "rxjs";
import { IAPIListResult, IPagination, IPaginationResult } from "app/common/interfaces";

import { ICreatePaymentBrand, IUpdatePaymentBrand } from "./interfaces/payment-brand.interface";
import PaymentBrandAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/payment-masters/payment-type/payment-brands/payment-brands.entity";

const apiUrl = env.API_PAYMENT_MASTER_URL;
const moduleName = "payment_brand";

@Injectable({
  providedIn: "root",
})
export class PaymentBrandService extends AbstractService<PaymentBrandAttributes, ICreatePaymentBrand, IUpdatePaymentBrand> {
    constructor(
        http: HttpClient,
    ) {
        super(apiUrl, moduleName, http);
    }

    /**
     * List
     * @param filter CombinedFilter of related entity - PaymentBrandAttributes
     * @returns Data list
     */
    getAllPaymentBrand(paymentTypeId: string): Observable<IAPIListResult<PaymentBrandAttributes>> {
        const API_URL: string = apiUrl + `api/${moduleName}/${paymentTypeId}`;
        return this.http.get<IAPIListResult<PaymentBrandAttributes>>(API_URL);
    }
}
